import React from 'react'
import { cn } from '../../lib/utils'

const baseClasses = 'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-60 active:scale-[0.97] active:transition-transform'

const buttonVariants = {
  default:
    'bg-white/20 text-slate-900 shadow-[0_6px_20px_rgba(15,23,42,0.15)] border border-white/50 backdrop-blur-xl hover:bg-white/30 hover:backdrop-blur-2xl dark:bg-white/10 dark:text-white dark:border-white/20 dark:hover:bg-white/20',
  secondary: 'bg-secondary-200 text-secondary-800 hover:bg-secondary-300 border border-secondary-300/60 shadow-sm dark:bg-secondary-800 dark:text-secondary-100 dark:hover:bg-secondary-700',
  destructive: 'bg-red-600 text-white hover:bg-red-700 border border-red-500/70 shadow-[0_4px_16px_rgba(220,38,38,0.35)]',
  glass: 'bg-white/20 text-white border border-white/35 backdrop-blur-lg shadow-[0_6px_20px_rgba(15,23,42,0.25)] hover:bg-white/25 dark:bg-white/10 dark:hover:bg-white/20 dark:border-white/25',
  outline: 'border border-primary-500/70 text-primary-600 hover:bg-primary-50 dark:text-primary-200 dark:hover:bg-primary-500/10',
  ghost: 'text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-800',
  link: 'text-primary-600 underline-offset-4 hover:underline dark:text-primary-300',
}

const buttonSizes = {
  default: 'px-4 py-2',
  sm: 'px-3 py-2 text-sm',
  lg: 'px-6 py-3 text-base',
  icon: 'h-10 w-10',
}

const Button = React.forwardRef(({ className, variant = 'default', size = 'default', ...props }, ref) => {
  const resolvedVariant = variant === 'primary' ? 'default' : variant
  const variantClass = buttonVariants[resolvedVariant] ?? buttonVariants.default
  const sizeClass = buttonSizes[size] ?? buttonSizes.default

  return (
    <button
      ref={ref}
      className={cn(baseClasses, variantClass, sizeClass, className)}
      {...props}
    />
  )
})

Button.displayName = 'Button'

export { Button, buttonVariants }
